import { createForm } from '../../../factories'

export default createForm(['email', 'name', 'password', 'recaptcha_token'])



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/signUp.js